import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { H2 } from 'foundations-components/transitional/components/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped import
import { useHideDialog } from '../../../dialog/ducks';
import { useState } from 'react';
import TagNameForm from '../TagForm';
import { DEFAULT_TAG_COLOR } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AddTagModal = () => {
  const [value, onChange] = useState('');
  const [color, setColor] = useState(DEFAULT_TAG_COLOR);
  const hideDialog = useHideDialog();
  const handleConfirm = () => {
    hideDialog();
  };
  return /*#__PURE__*/_jsxs(Modal, {
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: hideDialog
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.tagManager.modal.create.title"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(TagNameForm, {
        name: value,
        color: color,
        onNameChange: onChange,
        onColorChange: setColor
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: handleConfirm,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.tagManager.modal.create.confirm"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "secondary",
        onClick: hideDialog,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.tagManager.modal.create.cancel"
        })
      })]
    })]
  });
};
export default AddTagModal;